export default __webpack_public_path__ + "static/media/googleplay.4e1f889b.svg";